module.exports = {"CLAIM_CHART_TITLE":"Offres réclamées par jour/semaine/mois/année","DAY":"jour","WEEK":"semaine","MONTH":"mois","YEAR":"année","CLAIM_CHART_TOOLTIP":"Nombre de réclamations","SALES_CHART_TITLE":"Ventes par jour/semaine/mois/année","SALES_CHART_TOOLTIP":"Nombre de ventes"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/fr/charts.json
// module id = 430
// module chunks = 8